import { createClient } from "@supabase/supabase-js"

/**
 * The webapp's Supabase client (plan §9.2).
 *
 * The session is persisted to `localStorage` by the SDK and refreshed by it —
 * `authTokenProvider` in `main.tsx` only ever reads it. The anon key is public
 * by design; RLS and the backend's bearer check are the boundary.
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
)
